function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { isEmpty } from 'lodash';
import { stringify } from 'query-string';
import { HttpClient } from 'api/http-client';
import { getFormattedValueFromDateRange, Range } from 'components/organisms/projects-report/common/range-picker/types';
import { SourceType } from 'components/organisms/tasks/fields';
import { to_filter } from 'components/pages/api-filter-transformer';
import { fieldAccessMetaToBase3 } from 'utils/field-access';
import { ApiFilter, customFieldKeyToString } from 'utils/simple-search-filter/simple-search-filter';
const dateRangeToQueryString = (range)=>{
    if (range.type === Range.Overall) {
        return [
            '',
            ''
        ];
    }
    return getFormattedValueFromDateRange(range);
};
const filterToQueryString = (filter)=>{
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    const criteriaQuery = ApiFilter.toQueryStringFormat(filter.criteria);
    // @TODO: @kadhirr, please bring this back after time range is reimplemented
    // const [startDate, endDate] = dateRangeToQueryString(filter.range);
    return `${criteriaQuery}&${stringify({
        match: criteriaQuery.length ? filter.type : null
    }, {
        skipNull: true,
        skipEmptyString: true
    })}`;
};
const searchTextToQueryString = (searchText)=>isEmpty(searchText) ? '' : `&company*companyName.contains=${searchText}`;
const searchAndFilterToQueryString = (filter, searchText)=>filterToQueryString(filter) + searchTextToQueryString(searchText);
const groupByToString = (field)=>{
    return ![
        'companyStage',
        'companyHealth'
    ].includes(field.value) && (field.isCustomField || field.isUserField) ? customFieldKeyToString({
        fieldId: field.fieldId,
        sourceType: SourceType.Company
    }) : field.value;
};
class CustomerCompanyHttpClient extends HttpClient {
    async getAllCustomerCompanies() {
        return this.get('/companies', {
            params: {
                companyType: 'CUSTOMER'
            }
        });
    }
    async exportCustomerCompanies(data) {
        return this.post('/reports/company-list/export?match=all', data);
    }
    constructor(...args){
        super(...args), _define_property(this, "createCompany", (payload)=>{
            return this.post('/companies', payload);
        }), _define_property(this, "updateCompany", (companyId, payload)=>{
            return this.put(`/companies/${companyId}`, payload);
        }), _define_property(this, "getCompanyById", async (companyId, filter)=>{
            const [startDate, endDate] = filter ? dateRangeToQueryString(filter.range) : [
                '',
                ''
            ];
            return this.get(`/companies/${companyId}/customer-portfolio?${stringify({
                startDate,
                endDate
            }, {
                skipNull: true,
                skipEmptyString: true
            })}`).then((response)=>{
                var _response_fieldsAccessMeta;
                return {
                    ...response,
                    fieldsAccessMetaInBase3: fieldAccessMetaToBase3((_response_fieldsAccessMeta = response.fieldsAccessMeta) !== null && _response_fieldsAccessMeta !== void 0 ? _response_fieldsAccessMeta : {})
                };
            });
        }), _define_property(this, "getStatusUpdatesByCompanyId", async (companyId)=>{
            return this.get(`status-updates/companies/${companyId}`);
        }), _define_property(this, "getLayout", async ({ filter, columnGroup, searchText })=>this.get(`/companies/getlightkanbanCount?${searchAndFilterToQueryString(filter, searchText)}`, {
                params: {
                    columnGroup: groupByToString(columnGroup)
                }
            })), _define_property(this, "postLayout", async ({ filter, columnGroup, searchText })=>this.post(`/companies/getlightkanbanCount?${stringify({
                columnGroup: groupByToString(columnGroup),
                searchText
            }, {
                skipEmptyString: true,
                skipNull: true
            })}`, {
                filter: to_filter(filter)
            })), _define_property(this, "postCompaniesInSwimlanes", ({ filter, searchText, columnGroup, swimlaneIds })=>this.post(`/companies/getlightkanbanV1?${stringify({
                rowIds: swimlaneIds.join(','),
                columnGroup: groupByToString(columnGroup),
                searchText
            }, {
                skipEmptyString: true,
                skipNull: true
            })}`, {
                filter: to_filter(filter)
            }).then((response)=>response.kanbanResponseModelList)), _define_property(this, "getCompaniesInSwimlanes", ({ filter, searchText, columnGroup, swimlaneIds })=>this.get(`companies/getlightkanbanV1?${searchAndFilterToQueryString(filter, searchText)}`, {
                params: {
                    rowIds: swimlaneIds.join(','),
                    columnGroup: groupByToString(columnGroup)
                }
            }).then((response)=>response.kanbanResponseModelList)), _define_property(this, "getCompainesInSwimlaneColumn", ({ filter, searchText, offsetCol, columnGroup, colId, rowId })=>this.get(`companies/getlightkanbanColV1?${searchAndFilterToQueryString(filter, searchText)}`, {
                params: {
                    columnGroup: groupByToString(columnGroup),
                    colId,
                    rowId,
                    offsetCol,
                    limitCol: 10
                }
            })), _define_property(this, "dragAndDropCompany", ({ columnGroup, filter, searchText, fromRowId, fromColId, toRowId, toColId, companyId })=>this.get(`/companies/getDragAndDropAllowed?${searchAndFilterToQueryString(filter, searchText)}`, {
                params: {
                    columnGroup: groupByToString(columnGroup),
                    fromRowId,
                    fromColId,
                    toRowId,
                    toColId,
                    companyId,
                    rowGroup: 'company'
                }
            })), /**
   * Get valid reportees for a user (users who can report to this manager).
   * Backend returns full User objects.
   */ _define_property(this, "getValidManagerOfOptions", async (userId)=>{
            return this.get(`/users/valid-reportee/${userId}`);
        }), /**
   * Get valid managers for a user (users this person can report to).
   * Backend returns full User objects.
   */ _define_property(this, "getValidReportingToOptions", async (userId)=>{
            return this.get(`/users/valid-managers/${userId}`);
        }), _define_property(this, "getPeopleHierarchy", async (companyId)=>{
            return this.get(`/companies/${companyId}/hierarchy`);
        }), _define_property(this, "getCompanyPeopleList", async (companyId)=>{
            return this.get(`/companies/${companyId}/peopleV2`);
        }), _define_property(this, "getPaginatedCompanies", async ({ filter, searchText, sort, startRow, endRow })=>{
            return this.get(`/companies/searchlightV1?${searchAndFilterToQueryString(filter, searchText)}`, {
                params: {
                    sort,
                    offset: startRow,
                    limit: endRow - startRow
                }
            });
        }), _define_property(this, "postPaginatedCompanies", async ({ filter, searchText, sort, startRow, endRow })=>{
            const transformedFilter = to_filter(filter);
            return this.post(`/companies/searchlightV1${searchText ? `?searchValue=${searchText}` : ''}`, {
                filter: transformedFilter
            }, {
                params: {
                    sort,
                    offset: startRow,
                    limit: endRow - startRow
                }
            });
        }), _define_property(this, "getCompanyActivites", async ({ endDate, limit, lastActivityKey, companyId })=>this.get('/activities', {
                params: {
                    endDate,
                    offset: lastActivityKey,
                    limit,
                    filter: 'MONTH',
                    sourceId: companyId,
                    sourceType: 'COMPANY'
                }
            })), _define_property(this, "getCompanyActivitiesCount", async ({ companyId, yearsToBeFetched: years })=>this.get('/activities/count', {
                params: {
                    sourceId: companyId,
                    sourceType: 'COMPANY',
                    period: years.join(',')
                }
            })), _define_property(this, "deleteCustomerCompany", async (companyId)=>{
            return this.delete(`/companies/${companyId}`);
        }), _define_property(this, "mergeCompanies", async (sourceCompanyIds, destinationCompanyId)=>{
            return this.put('/companies/merge', {}, {
                params: {
                    childCompanyIds: encodeURI(sourceCompanyIds.toString()),
                    parentCompanyId: destinationCompanyId
                }
            });
        });
    }
}
export const CustomerCompanyAPI = new CustomerCompanyHttpClient();
